var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread"},_vm._l((_vm.list),function(item,index){return _c('span',{key:item,class:index === _vm.list.length - 1 ? 'normal active' : 'normal'},[_vm._v(_vm._s(index === _vm.list.length - 1 ? item : (item + "/")))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }